import React from 'react';
import { Handshake, Crown, BookOpen } from "lucide-react";
import { HeroBackgroundStrokes } from '../components/common/SyncratikLogo';

const AboutUsPage = () => {
    return (
        <div className="bg-gray-10 min-h-screen relative pt-16 lg:pt-60 pb-60">
            {/* Background with logo strokes */}
            <div className="absolute inset-0 pointer-events-none overflow-hidden">
                <HeroBackgroundStrokes
                    className="absolute inset-0 w-full"
                    style={{
                        height: '100%',
                        backgroundImage: 'url(/assets/logo-strokes.png)',
                        backgroundRepeat: 'repeat-y',
                        backgroundSize: '100% 2216px',
                        backgroundPosition: 'center top'
                    }}
                />
            </div>

            <div className="relative container-content">
                {/* Header Section */}
                <div className="text-center mb-16 pb-16">
                    <h1 className="text-h1 md:text-h0 text-gray-95 mb-6">All the Power of AI <br />None of its Complexity</h1>
                    <p className="text-subheading text-gray-90 max-w-3xl mx-auto">
                        Syncratik makes tailored turnkey AI solutions effortlessly accessible for every business and individual.</p>
                </div>

                {/* Mission Section */}
                <div className="mb-16">
                    <div className="pb-16">
                        <h2 className="text-h2 text-gray-95 mb-6 text-center">About Us</h2>
                        <p className="text-paragraph text-gray-80 text-center max-w-4xl mx-auto">
                            Syncratik specializes in human-interfacing agentic AI systems, leveraging cutting-edge techniques like RAG and MCP to
                            create customized solutions that go beyond simple automation. Our approach empowers human and AI interactions to be
                            more empathetic and helpful. By partnering with Syncratik, businesses can accelerate growth on a leaner operational
                            footprint while our intelligent systems handle the rest.
                        </p>
                    </div>
                </div>

                {/* Values Section */}
                <div className="mb-16 pb-16">
                    <h2 className="text-h2 text-gray-95 text-center mb-6">Our Values</h2>
                    <div className="grid md:grid-cols-3 gap-8">
                        <div className="text-center">
                            <div className="w-16 h-16 bg-purple-60 rounded-full flex items-center justify-center mx-auto mb-4">
                                <Crown className="w-8 h-8 text-gray-95" strokeWidth={2} />
                            </div>
                            <h3 className="text-h3 text-gray-95 mb-3">Client-First</h3>
                            <p className="text-paragraph text-gray-70">
                                Purpose-driven innovation to curate the best experience for our customers.
                            </p>
                        </div>

                        <div className="text-center">
                            <div className="w-16 h-16 bg-purple-60 rounded-full flex items-center justify-center mx-auto mb-4">
                                <Handshake className="w-8 h-8 text-gray-95" strokeWidth={2} />
                            </div>
                            <h3 className="text-h3 text-gray-95 mb-3">Collaboration</h3>
                            <p className="text-paragraph text-gray-70">
                                Your voice is not just heard but instrumental in shaping our products and direction.
                            </p>
                        </div>

                        <div className="text-center">
                            <div className="w-16 h-16 bg-purple-60 rounded-full flex items-center justify-center mx-auto mb-4">
                                <BookOpen className="w-8 h-8 text-gray-95" strokeWidth={2} />
                            </div>
                            <h3 className="text-h3 text-gray-95 mb-3">Transparency</h3>
                            <p className="text-paragraph text-gray-70">
                                We commit to clear foundations and shared growth to build a relationship on trust.
                            </p>
                        </div>
                    </div>
                </div>

                {/* Team Section */}
                <div className="text-center">
                    <h2 className="text-h2 text-gray-95 mb-6">Join Our Journey</h2>
                    <p className="text-paragraph text-gray-70 max-w-3xl mx-auto mb-4">
                        We're building the future of AI-powered business solutions. Whether you're looking to
                        transform your operations or join our team, we'd love to hear from you.
                    </p>
                    <div className="flex flex-col sm:flex-row gap-6 justify-center">
                        <a
                            href="/contact"
                            className="btn-primary"
                        >
                            Get in Touch
                        </a>
                        <a
                            href="/pricing"
                            className="btn-primary-outline"
                        >
                            View Pricing
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AboutUsPage;
